export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE_XENATUS2:'SET_FETCHED_QUESTIONS_TO_STATE_XENATUS2',
    SET_SELECTED_QUESTION_XENATUS2:'SET_SELECTED_QUESTION_XENATUS2',
    SELECTED_QUESTION_NEXT_XENATUS2:'SELECTED_QUESTION_NEXT_XENATUS2',
    SELECTED_QUESTION_PREVIOUS_XENATUS2:'SELECTED_QUESTION_PREVIOUS_XENATUS2',
    SET_SELECTED_ANSWER_XENATUS2:'SET_SELECTED_ANSWER_XENATUS2',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}